const GoldChain = {
    hex: '0x777771',
    name: 'GoldChain',
    rpcUrl: 'https://rpc.goldchain.tech/',
    ticker: "BAIT"
};

const MumbaiTestnet = {
   hex: '0x13881',
   name: 'Mumbai Testnet',
   rpcUrl: 'https://polygon-mumbai.infura.io/v3/4458cf4d1689497b9a38b1d6bbf05e78',
  ticker: "MATIC"
};

const Polygon = {
  hex: "0x89",
  name: "Polygon",
  rpcUrl: "https://polygon-bor.publicnode.com",
  ticker: "POL",
};
const Ethereum = {
    hex: '0x1',
    name: 'Ethereum',
    rpcUrl: 'https://eth.drpc.org',
    ticker: "ETH"
};

export const CHAINS_CONFIG = {
    "0x777771": GoldChain,
   "0x13881": MumbaiTestnet,
    "0x89": Polygon,
    "0x1": Ethereum,
};